import React, { useEffect, useState } from "react";
import styled from "styled-components";
import menu from "../Assets/menu.png";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import LandingConnector from "../Landing/Connector/LandingConnector";
import xook from "../Assets/Xook.png";
import Button from "../Generic/Button";
import SuccessButton from "../Generic/SuccessButton";
import { LogoutUser } from "../Login/Service/LoginService";
import { CSSTransition } from "react-transition-group";
import close from "../Assets/Close.png";
import blankProfile from "../Assets/blankProfile.png";
import { signOut } from "supertokens-auth-react/recipe/session";
import { beautifyKey, isEmpty } from "../util/util";
import FreshchatService from "../thirdparty/FreshchatService";
import { errorNotification } from "../Generic/Notifications";
import { get } from "../config/api";
import Loader from "../Generic/Loader";
import { SERVER_URL } from "../config/app.config";

const Head = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 4.5rem;
	padding: 0 1rem;
	background: #fff;
	z-index: 105;
`;

const Item = styled.div`
	display: flex;
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	flex-direction: ${(props) => props.flexDirection};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	font-size: ${(props) => props.fontSize};
	height: ${(props) => props.height};
`;

const SubItem = styled.div`
	display: block;
	margin: ${(props) => props.margin};
	font-family: ${(props) => props.fontFamily};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
`;

const Div = styled.div`
	height: ${(props) => props.height};
	position: ${(props) => props.postition};
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	display: ${(props) => props.display ?? "flex"};
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	width: ${(props) => props.width};
	z-index: ${(props) => props.zIndex};
	border-radius: ${(props) => props.borderRadius};
	overflow: ${(props) => props.overflow};
	border-top: ${(props) => props.borderTop};
	align-self: ${(props) => props.alignSelf};
	gap: ${(props) => props.gap};
	&:hover {
		background: ${(props) => props.hoverBackground};
	}
`;

const Seperator = styled.div`
	margin: 0 1rem;
	border-top: 1px solid rgba(0, 0, 0, 0.2);
`;

const AccountDrop = styled.div`
	border-radius: 10px;
	overflow-x: hidden;
	position: absolute;
	top: 4.8rem;
	right: 1rem;
	height: max-content;
	width: 18rem;
	background: #fff;
	z-index: 299;
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

const Span = styled.span`
	font-size: 2.5rem;
	user-select: none;
	&:hover {
		transform: scale(1.1);
		transition: 0.6s all ease-in-out;
	}
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 310;
`;

const Modal = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	width: 30rem;
	overflow-x: hidden;
	border-radius: 10px;
	z-index: 305;
	@media (max-width: 1000px) {
		width: ${(props) => props.widthBefore1000};
	}
`;

const Header = (props) => {
	const [dropdown, showDropdown] = useState(false);
	const [modal, showModal] = useState(false);
	const [userDetailsLoading, setUserDetailsLoading] = useState(false);
	const [userDetails, setUserDetails] = useState({});
	const [helpDeskLoading, setHelpDeskLoading] = useState(false);

	const navigate = useNavigate();

	async function signOutUuser() {
		await signOut();
		navigate("/auth");
	}

	async function getUserDetails() {
		const response = get({ url: SERVER_URL + "/v1/admin/user/info" });
		const { data } = await response;
		if (data) {
			setUserDetails(data);
			// Set user email in Freshchat
			if (data.id) {
				FreshchatService.setUserDetails(data.id);
			}
		}

		setUserDetailsLoading(false);
	}

	async function openHelpDesk() {
		setHelpDeskLoading(true);
		const { error } = await FreshchatService.openFreshchatHelpDesk();
		setHelpDeskLoading(false);
		if (error) {
			errorNotification(error);
		} else {
			showDropdown(false);
		}
	}

	useEffect(() => {
		getUserDetails();
	}, []);

	function renderUserDetails(userDetails, isLoading) {
		if (isLoading) {
			return <Loader />
		}

		if (!isEmpty(userDetails)) {
			return (
				<>
					<Div jContent="center" alignItem="center" overflow="hidden" borderRadius="50%">
						<img style={{ height: "3.5rem" }} src={blankProfile} alt="profile" />
					</Div>
					<Div margin="1rem 0 0 0">{userDetails?.id}</Div>
				</>
			);
		} else {
			<Div margin="1rem 0 0 0">Something Went Wrong!</Div>
		}
	}

	return (
		<Head>
			<Div height="100%">
				<Item margin="0 0.5rem 0 0" alignItem="center">
					{window.innerWidth < 1024 && props.toggle ? (
						<img src={menu} alt="menu" style={{ height: "2.5rem" }} onClick={() => props.toggle(!props.showSidebar)} />
					) : (
						<NavLink to={"/"}>
							<img src={xook} alt="logo" style={{ height: "2.5rem" }} />{" "}
						</NavLink>
					)}
				</Item>
				{props.machinePage ? (
					<>
						<Item padding="0 0 0 0.5rem" flexDirection="column" jContent="center" alignItem="left">
							<NavLink to={"/"}>
								<SubItem fontSize="1.3rem" fontWeight="600">
									{props.location}
								</SubItem>
								<SubItem margin="0.2rem 0 0 0" fontWeight="300">
									{props.machineID}
								</SubItem>
							</NavLink>
						</Item>
						<NavLink to={"/"}>
							<Item fontSize="1.1rem" height="100%" alignItem="center" margin="0 0 0 0.5rem">
								<span className="material-symbols-outlined">expand_more</span>
							</Item>
						</NavLink>
					</>
				) : (
					<Div margin="0 0 0.8rem 0.5rem" display="inline-block" alignSelf="flex-end" jContent="flex-end" fontSize="1.3rem">
						{props.title}
					</Div>
				)}
			</Div>
			<Div gap="1rem" alignItem="center" jContent="center">
				<span style={{ fontSize: "2rem", cursor: "pointer" }} className="material-symbols-outlined" onClick={openHelpDesk}>
					chat_info
				</span>
				<Span style={{ cursor: "pointer" }} className="material-symbols-outlined" onClick={() => showDropdown((initialState) => !initialState)}>
					person
				</Span>
			</Div>
			<CSSTransition in={dropdown} timeout={1000} classNames="page" unmountOnExit>
				<AccountDrop>
					<Div flexDirection="column" padding="1rem" jContent="center" alignItem="center">
						{renderUserDetails(userDetails, userDetailsLoading)}
					</Div>
					<Seperator />
					<Div onClick={() => showModal(true)} zIndex="999" padding="1rem" hoverBackground="#faebd7">
						<span className="material-symbols-outlined">logout</span>
						&nbsp; Logout
					</Div>
				</AccountDrop>
			</CSSTransition>

			<CSSTransition in={modal} timeout={1000} classNames="container" unmountOnExit>
				<Overlay>
					<Modal>
						<Div alignItem="center" background="rgba(45, 35, 66, 0.8)" color="#fff" padding="1rem" jContent="space-between">
							<Div fontSize="1.4rem">Are you sure you want to Logout?</Div>
							<img
								style={{
									height: "1.5rem",
									filter: "invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
								src={close}
								alt="close"
								onClick={() => {
									showModal(false);
								}}
							/>
						</Div>
						<Div padding="1rem" width="100%" jContent="flex-end">
							<Div
								width="max-content"
								margin="0.5rem"
								onClick={() => {
									showModal(false);
								}}>
								<Button>Cancel</Button>
							</Div>
							<Div width="max-content" margin="0.5rem">
								<SuccessButton onClick={signOutUuser}>Confirm</SuccessButton>
							</Div>
						</Div>
					</Modal>
				</Overlay>
			</CSSTransition>

			{helpDeskLoading && (
				<Overlay>
					<Div flexDirection="column" alignItem="center" jContent="center">
						<Loader />
						<Div color="#fff" margin="1rem 0 0 0" fontSize="1.1rem">Opening Help Desk...</Div>
					</Div>
				</Overlay>
			)}
		</Head>
	);
};

export default LandingConnector(Header);
